import { Controller } from "@hotwired/stimulus"
import { installPromptAvailable, isIos, isStandalone, promptInstall, serviceWorkerSupported } from "../lib/pwa"

// Карточка «Установить приложение» в личном кабинете.
//
// Разметка приходит скрытой, и показывает её этот контроллер — потому что
// сервер не знает ни того, установлено ли уже приложение, ни того, умеет ли
// браузер его устанавливать. Показывать нечего в двух случаях: человек уже
// внутри установленного приложения и браузер не поддерживает установку вовсе
// (десктопный Firefox).
//
// Два способа установки, и выбор между ними — не про красоту: Chrome и его
// производные дают событие `beforeinstallprompt` и системное окно, а Safari на
// iOS не даёт ничего, и там единственный способ — рассказать про «Поделиться»
// → «На экран «Домой»».
export default class extends Controller {
  static targets = ["prompt", "manual", "button"]

  connect() {
    this.onInstallable = () => this.reveal()
    this.onInstalled = () => this.hide()

    window.addEventListener("pwa:installable", this.onInstallable)
    window.addEventListener("pwa:installed", this.onInstalled)

    this.reveal()
  }

  disconnect() {
    window.removeEventListener("pwa:installable", this.onInstallable)
    window.removeEventListener("pwa:installed", this.onInstalled)
  }

  reveal() {
    const installable = installPromptAvailable()
    // На iOS ручная инструкция — единственный вариант; в остальных браузерах
    // она бесполезна, поэтому карточки просто нет, пока не пришло событие.
    const manual = !installable && isIos() && serviceWorkerSupported()

    // Прячем явно, а не «оставляем как есть»: скрытая разметка приходит с
    // сервера только при первой отрисовке, а дальше Turbo восстанавливает
    // страницу из своего снимка — снятого, возможно, когда карточка была видна.
    // Установленное с тех пор приложение получило бы карточку с мёртвой кнопкой.
    if (isStandalone() || (!installable && !manual)) return this.hide()

    this.promptTarget.hidden = !installable
    this.manualTarget.hidden = !manual
    this.element.hidden = false
  }

  hide() {
    this.element.hidden = true
  }

  async install() {
    this.buttonTarget.disabled = true

    try {
      await promptInstall()
    } finally {
      // Отказ от установки — не конец: окно можно вызвать снова, но уже другим
      // событием, поэтому карточка прячется, а не остаётся с мёртвой кнопкой.
      this.buttonTarget.disabled = false
      if (!installPromptAvailable()) this.hide()
    }
  }
}
